import { globalAccessToken } from 'hooks/use-auth'
import { createRequest, createRequestMethods } from 'lib/request'

export const { get, post, put, del, patch, options } = createRequestMethods(
  createRequest((requestInit) => {
    // TODO: Consider replacing with an injectable service.
    const headers = new Headers(requestInit.headers)

    if (globalAccessToken !== null) {
      headers.set('Authorization', `Bearer ${globalAccessToken}`)
    }

    return {
      ...requestInit,
      headers,
    }
  }),
)
